/** Localities query hooks. */
import { useQuery } from "@tanstack/react-query";

import {
  fetchLocalities,
  fetchLocalityHouses,
  fetchLocalityStats,
  fetchLocalityTopConsumers,
  fetchLocalityTrends,
} from "@/features/localities/api";
import { thresholds } from "@/lib/thresholds";

const MINUTE = 60_000;

export const useLocalities = () =>
  useQuery({
    queryKey: ["localities", "list"],
    queryFn: ({ signal }) => fetchLocalities(signal),
    staleTime: 10 * MINUTE,
  });

export const useLocalityStats = (name: string) =>
  useQuery({
    queryKey: ["localities", name, "stats"],
    queryFn: ({ signal }) => fetchLocalityStats(name, signal),
    staleTime: 5 * MINUTE,
    enabled: !!name,
  });

export const useLocalityTrends = (
  name: string,
  days = thresholds().default_analysis_days,
) =>
  useQuery({
    queryKey: ["localities", name, "trends", days],
    queryFn: ({ signal }) => fetchLocalityTrends(name, days, signal),
    staleTime: 10 * MINUTE,
    enabled: !!name,
  });

export const useLocalityHouses = (
  name: string,
  days = thresholds().default_analysis_days,
) =>
  useQuery({
    queryKey: ["localities", name, "houses", days],
    queryFn: ({ signal }) => fetchLocalityHouses(name, days, signal),
    staleTime: 10 * MINUTE,
    enabled: !!name,
  });

export const useLocalityTopConsumers = (name: string, limit = 10) =>
  useQuery({
    queryKey: ["localities", name, "top", limit],
    queryFn: ({ signal }) => fetchLocalityTopConsumers(name, limit, signal),
    staleTime: 10 * MINUTE,
    enabled: !!name,
  });
